import _ from 'lodash';
import { useContext, useEffect, useRef, useState } from 'react';
import { faSync } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ApplicableTableSettings, codesCurrencyList } from '../../../../tableSettings';
import ApplicationContext from '../../../../ApplicationContext';
import useGlobalOkDialog from '../../../../hooks/useGlobalOkDialog';
import useFastStorage, { useTypedFastStorage } from '../../../../hooks/useFastStorage';
import useFunction from '../../../../hooks/useFunction';
import { ApiResult, InsertResult } from '../../../../framework.core/data/ApiResult';
import { JobNames } from '../../../../framework.core/JobNames';
import { CodeCurrencyListItem } from '../../../../fms.data/models/CodeCurrencyListItem';
import { isFilterObjectEmpty, getInitialSearch, Search } from '../../../../filtering';
import { FmsSecTask } from '../../../../fms.core/constants';
import useFunctionKeys from '../../../../hooks/useFunctionKeys';
import { appendLine, duplicateCell, findSecurityTask } from '../../../../util';
import BlackInverseButton from '../../../../ui/BlackInverseButton';
import constants from '../../../../constants';
import useFilterBar from '../../../../hooks/useFilterBar';
import { ListOrderBy } from '../../../common/AbstractListView';
import EditableTable, { CellData, TableCellAligns, TableCellTypes } from '../../../../ui/tables/editing/EditableTable';
import { checkTabIsDirty, sortingListData } from '../../ReferenceFiles';
import TextBox from '../../../../ui/TextBox';
import { Portal } from 'react-portal';
import GreenButton from '../../../../ui/GreenButton';
import { SQLType } from '../../../../framework.core/data/SQLInfo';
import Number from '../../../../ui/Number';
import IFmsReferenceFilesContext from '../../IfmsReferenceFilesContext';
import CloseButton from '../../../../ui/CloseButton';
import { Currency } from '../../../../ifmsTypes';
import { RefreshIconButton2 } from '../../../../ui/IconButton';

// function ActionRenderer({ data, row }:any) {
//   if (data[row.index].editIndex !== row.index) {
//     return null;
//   }

//   return (
//     <div style={{textAlign: 'left', marginLeft: '10px'}}>
//       <PrimaryInverseButton
//         disabled={data[row.index].editIndex !== row.index}
//         style={{fontSize: '14px', lineHeight: '14px', margin: '0', padding: '0'}}
//         data-tooltip="Cancel"
//         
//         onClick={() => data[row.index].isNew ? data[row.index].onDelete() : data[row.index].requestOperationCancel()}
//       >
//         <FontAwesomeIcon icon={faTimes} />
//       </PrimaryInverseButton>&nbsp;&nbsp;
//       <PrimaryInverseButton
//         disabled={data[row.index].editIndex !== row.index}
//         style={{fontSize: '14px', lineHeight: '14px', margin: '0', padding: '0'}}
//         data-tooltip="Save"
//         
//         onClick={() => data[row.index].onSave()}
//       >
//         <FontAwesomeIcon icon={faSave} />
//       </PrimaryInverseButton>&nbsp;&nbsp;
//       {!data[row.index].isNew &&
//         <>
//           <PrimaryInverseButton
//             disabled={data[row.index].editIndex !== row.index}
//             style={{fontSize: '14px', lineHeight: '14px', margin: '0', padding: '0'}}
//             data-tooltip="Delete"
//             
//             onClick={() => data[row.index].onDelete()}
//           >
//             <FontAwesomeIcon icon={faTrashAlt} />
//           </PrimaryInverseButton>
//         </>
//       }
//     </div>
//   );
// }

// function RowSpacer() {
//   return (
//     <div style={{height: '10px'}}>&nbsp;</div>
//     );
//   }

// jhlee 241113 : List에서 바로 입력 가능하도록 변경
// function CurrencyDetail({
//   readonly,
//   currency,
//   onChange
// }:{
//   readonly: boolean,
//   currency: NCodeCurrency,
//   onChange: (change: Partial<NCodeCurrency>) => void
// }) {
//   const [testAmount, setTestAmount] = useState<number|null>(null);
//   const [showGlobalOkDialog] = useGlobalOkDialog();
//   return (
//     <div>
//       <div style={{float: 'left', marginRight: '10px', width: 'calc(25% - 10px)'}}>
//         <RowSpacer />

//         <LeftRightSplit
//           left={
//             <div style={{marginRight: '10px'}}>
//               <InputControlRow label={<span>Currency Code <span style={{color: 'red'}}>*</span></span>}>
//                 <TextBox name='codes-currency-code' textId='currency-code' maxLength={3} data-validationfor="code" disabled={currency && currency.id > 0} value={currency?.code || ''} onChange={e => onChange({code: e.target.value})} />
//               </InputControlRow>
//             </div>
//           }
//           right={
//             <div style={{marginLeft: '10px'}}>
//               <InputControlRow label={
//                 <LeftRightSplit
//                   leftSize="30px"
//                   rightSize="calc(100% - 30px)"
//                   left={
//                     <div id='codes-currency-inactive' style={{position: 'relative', top: '-2px'}}>
//                       <CheckBox name='codes-currency-inactive' disabled={readonly}  value={currency?.inactive || false} onChange={inactive => onChange({inactive})} />
//                     </div>
//                   }
//                   right={
//                     <>Inactive</>
//                   }
//                 />
//               }>&nbsp;</InputControlRow>
//             </div>
//           }
//         />

        // <LeftRightSplit
        //   left={
        //     <div style={{marginRight: '10px'}}>
        //       <InputControlRow label="Base Unit Size">
        //         <Number name='codes-currency-baseUnitSize' max={999999999} min={0} data-validationfor="baseUnitSize" disabled={readonly} value={currency?.xSize} onChange={baseUnitSize => onChange({xSize: baseUnitSize ?? undefined})} />
        //       </InputControlRow>
        //     </div>
        //   }
        //   right={
        //     <div style={{marginLeft: '10px'}}>
        //       <InputControlRow label="Decimal Digit">
        //         <Number name='codes-currency-decimal' max={9} min={0} data-validationfor="decimal" disabled={readonly} value={currency?.decimal} onChange={decimal => onChange({decimal: decimal ?? undefined})} />
        //       </InputControlRow>
        //     </div>
        //   }
        // />

//         <LeftRightSplit
//           left={
//             <div style={{marginRight: '10px'}}>
//               <InputControlRow label="Symbol">
//                 <TextBox name='codes-currency-symbol' maxLength={6} data-validationfor="symbol" disabled={readonly} value={currency?.symbol || ''} onChange={e => onChange({symbol: e.target.value})} />
//               </InputControlRow>
//             </div>
//           }
//           right={
//             <div style={{marginLeft: '10px'}}>
//               <InputControlRow label="Local Symbol">
//                 <TextBox name='codes-currency-lSymbol' maxLength={6} data-validationfor="localSymbol" disabled={readonly} value={currency?.lSymbol || ''} onChange={e => onChange({lSymbol: e.target.value})} />
//               </InputControlRow>
//             </div>
//           }
//         />

//         <LeftRightSplit
//           left={
//             <div style={{marginRight: '10px'}}>
//               <InputControlRow label="H. Separate">
//                 <TextBox name='codes-currency-hSeparate' maxLength={5} data-validationfor="hundredSeparate" disabled={readonly} value={currency?.hundred_Sep || ''} onChange={e => onChange({hundred_Sep: e.target.value})} />
//               </InputControlRow>
//             </div>
//           }
//           right={
//             <div style={{marginLeft: '10px'}}>
//               <InputControlRow label="Suffix">
//                 <TextBox name='codes-currency-suffix' maxLength={30} data-validationfor="suffix" disabled={readonly} value={currency?.suffix || ''} onChange={e => onChange({suffix: e.target.value})} />
//               </InputControlRow>
//             </div>
//           }
//         />

//         <LeftRightSplit
//           left={
//             <div style={{marginRight: '10px'}}>
//               <InputControlRow label="Comma Words">
//                 <TextBox name='codes-currency-commaWords' maxLength={20} data-validationfor="commaWords" disabled={readonly} value={currency?.commaWords || ''} onChange={e => onChange({commaWords: e.target.value})} />
//               </InputControlRow>
//             </div>
//           }
//           right={
//             <div style={{marginLeft: '10px'}}>
//               <InputControlRow label="Divide Words">
//                 <TextBox name='codes-currency-divideWords' maxLength={20} data-validationfor="divideWords" disabled={readonly} value={currency?.sepWords || ''} onChange={e => onChange({sepWords: e.target.value})} />
//               </InputControlRow>
//             </div>
//           }
//         />

//       <InputControlRow label="Cents Type">
//         <div style={{width: '160px', fontSize: '10px', display: 'flex', justifyContent: 'space-between'}}>
//           <div><RadioButton radioId='codes-currency-centstype-numeric' group="currency-cents-type" reverse label="Numeric" checked={currency.cMode === 'N'} onChecked={() => onChange({cMode: 'N'})} disabled={readonly} /></div>
//           <div><RadioButton radioId='codes-currency-centstype-characters' group="currency-cents-type" reverse label="Characters" checked={currency.cMode !== 'N'} onChecked={() => onChange({cMode: ''})} disabled={readonly} /></div>
//         </div>
//       </InputControlRow>

//       <LeftRightSplit
//           left={
//             <div style={{marginRight: '10px'}}>
//               <InputControlRow label="Cents Name">
//                 <TextBox name='codes-currency-centsName' maxLength={20} data-validationfor="centsName" disabled={readonly} value={currency?.centName || ''} onChange={e => onChange({centName: e.target.value})} />
//               </InputControlRow>
//             </div>
//           }
//           right={
//             <div style={{marginLeft: '10px'}}>
//               <InputControlRow label="Zero Cents">
//                 <TextBox name='codes-currency-zeroCents' maxLength={20} data-validationfor="zeroCents" disabled={readonly} value={currency?.zeroCent || ''} onChange={e => onChange({zeroCent: e.target.value})} />
//               </InputControlRow>
//             </div>
//           }
//         />

//         <InputControlRow label=" ">
//           <LeftRightSplit
//             leftSize="30px"
//             rightSize="calc(100% - 30px)"
//             left={
//               <div id='codes-currency-useBlockSpace'>
//                 <CheckBox name='codes-currency-useBlockSpace' disabled={readonly}  value={currency?.bUseSpace || false} onChange={useBlockSpace => onChange({bUseSpace: useBlockSpace})} />
//               </div>
//             }
//             right={
//               <>Use Block Space</>
//             }
//           />
//         </InputControlRow>

//         <InputControlRow label=" ">
//           <LeftRightSplit
//             leftSize="30px"
//             rightSize="calc(100% - 30px)"
//             left={
//               <div id='codes-currency-useMiddleZeroWords'>
//                 <CheckBox name='codes-currency-useMiddleZeroWords' disabled={readonly}  value={currency?.useMiddleZWords || false} onChange={useMiddleZeroWords => onChange({useMiddleZWords: useMiddleZeroWords})} />
//               </div>
//             }
//             right={
//               <>Use Middle Zero Words</>
//             }
//           />
//         </InputControlRow>

//         <InputControlRow label=" ">
//           <LeftRightSplit
//             leftSize="30px"
//             rightSize="calc(100% - 30px)"
//             left={
//               <div id='codes-currency-noSuffixWithLowestBaseUnit'>
//                 <CheckBox name='codes-currency-noSuffixWithLowestBaseUnit' disabled={readonly}  value={currency?.noUseSuffixWhen || false} onChange={noSuffixWithLowestBaseUnit => onChange({noUseSuffixWhen: noSuffixWithLowestBaseUnit})} />
//               </div>
//             }
//             right={
//               <>No Use Suffix when the lowest Base Unit was used</>
//             }
//           />
//         </InputControlRow>

//       </div>

//       <div style={{float: 'left', marginLeft: '10px', marginRight: '10px', width: 'calc(50% - 10px)'}}>
//         <RowSpacer />

//         <img src={currencyTerminology} alt="Currency Terminology" />

//         <div style={{float: 'left', marginRight: '10px', width: 'calc(50% - 10px)', position: 'relative'}}>
//           <RowSpacer />

//           <LeftRightSplit
//             left={
//               <div style={{marginRight: '10px'}}>
//                 <InputControlRow label="10^(-2)">
//                   <TextBox name='codes-currency-xD2' maxLength={20} data-validationfor="baseUnitM2" disabled={readonly} value={currency?.xD2 || ''} onChange={e => onChange({xD2: e.target.value})} />
//                 </InputControlRow>
//               </div>
//             }
//             right={
//               <div style={{marginLeft: '10px'}}>
//                 <InputControlRow label="10^(-1)">
//                   <TextBox name='codes-currency-xD1' maxLength={20} data-validationfor="baseUnitM1" disabled={readonly} value={currency?.xD1 || ''} onChange={e => onChange({xD1: e.target.value})} />
//                 </InputControlRow>
//               </div>
//             }
//           />

//           <LeftRightSplit
//             left={
//               <div style={{marginRight: '10px'}}>
//                 <InputControlRow label="10^(0)">
//                   <TextBox name='codes-currency-x0' maxLength={20} data-validationfor="baseUnit0" disabled={readonly} value={currency?.x0 || ''} onChange={e => onChange({x0: e.target.value})} />
//                 </InputControlRow>
//               </div>
//             }
//             right={
//               <div style={{marginLeft: '10px'}}>
//                 <InputControlRow label="10^(1)">
//                   <TextBox name='codes-currency-x1' maxLength={20} data-validationfor="baseUnit1" disabled={readonly} value={currency?.x1 || ''} onChange={e => onChange({x1: e.target.value})} />
//                 </InputControlRow>
//               </div>
//             }
//           />

//           <LeftRightSplit
//             left={
//               <div style={{marginRight: '10px'}}>
//                 <InputControlRow label="10^(2)">
//                   <TextBox name='codes-currency-x2' maxLength={20} data-validationfor="baseUnit2" disabled={readonly} value={currency?.x2 || ''} onChange={e => onChange({x2: e.target.value})} />
//                 </InputControlRow>
//               </div>
//             }
//             right={
//               <div style={{marginLeft: '10px'}}>
//                 <InputControlRow label="10^(3)">
//                   <TextBox name='codes-currency-x3' maxLength={20} data-validationfor="baseUnit3" disabled={readonly} value={currency?.x3 || ''} onChange={e => onChange({x3: e.target.value})} />
//                 </InputControlRow>
//               </div>
//             }
//           />

//           <LeftRightSplit
//             left={
//               <div style={{marginRight: '10px'}}>
//                 <InputControlRow label="10^(4)">
//                   <TextBox name='codes-currency-x4' maxLength={20} data-validationfor="baseUnit3" disabled={readonly} value={currency?.x4 || ''} onChange={e => onChange({x4: e.target.value})} />
//                 </InputControlRow>
//               </div>
//             }
//             right={
//               <div style={{marginLeft: '10px'}}>
//                 <InputControlRow label="10^(5)">
//                   <TextBox name='codes-currency-x5' maxLength={20} data-validationfor="baseUnit4" disabled={readonly} value={currency?.x5 || ''} onChange={e => onChange({x5: e.target.value})} />
//                 </InputControlRow>
//               </div>
//             }
//           />

//           <InputControlRow label={
//             <LeftRightSplit
//               leftSize="30px"
//               rightSize="calc(100% - 30px)"
//               left={
//                 <div id='codes-currency-xUseSpace'>
//                   <CheckBox name='codes-currency-xUseSpace' disabled={readonly}  value={currency?.xUseSpace || false} onChange={useSpaceBaseUnit => onChange({xUseSpace: useSpaceBaseUnit})} />
//                 </div>
//               }
//               right={
//                 <>Use Space</>
//               }
//             />
//           }>
//             &nbsp;
//           </InputControlRow>
//           <div style={{position: 'absolute', bottom: '245px', right: '-375px'}}>
//             <InputControlRow label=" ">
//               <LeftRightSplit
//                 leftSize="30px"
//                 rightSize="calc(100% - 30px)"
//                 left={
//                   <div id='codes-currency-useHundred'>
//                     <CheckBox name='codes-currency-useHundred' disabled={readonly} value={currency?.useHundred || false} onChange={useHundredNumber => onChange({useHundred: useHundredNumber})} />
//                   </div>
//                 }
//                 right={
//                   <>Use Hundred Number</>
//                 }
//               />
//             </InputControlRow>

//             <LeftRightSplit
//               left={
//                 <div style={{marginRight: '10px'}}>
//                   <InputControlRow label="Amount">
//                     <Float name='codes-currency-testAmount' max={999999999999999999999} min={0} decimals={2} disabled={readonly} value={testAmount} onChange={setTestAmount} />
//                   </InputControlRow>
//                 </div>
//               }
//               right={
//                 <div style={{marginLeft: '0px'}}>
//                   <InputControlRow label=" ">
//                     <PrimaryButton name='codes-currency-testBtn' size="small" disabled={readonly} onClick={cmTest}>Test</PrimaryButton>
//                   </InputControlRow>
//                 </div>
//               }
//             />

//           </div>
//         </div>

//         <div style={{float: 'left', marginRight: '10px', width: 'calc(50% - 10px)'}}>
//             <RowSpacer />

//             <LeftRightSplit
//               left={
//                 <div style={{marginRight: '10px'}}>
//                   <InputControlRow label="0">
//                     <TextBox name='codes-currency-u0' maxLength={20} data-validationfor="blockUnit0" disabled={readonly} value={currency?.u0 || ''} onChange={e => onChange({u0: e.target.value})} />
//                   </InputControlRow>
//                 </div>
//               }
//               right={
//                 <div style={{marginLeft: '10px'}}>
//                   <InputControlRow label="1">
//                     <TextBox name='codes-currency-u1' maxLength={20} data-validationfor="blockUnit1" disabled={readonly} value={currency?.u1 || ''} onChange={e => onChange({u1: e.target.value})} />
//                   </InputControlRow>
//                 </div>
//               }
//             />

//             <LeftRightSplit
//               left={
//                 <div style={{marginRight: '10px'}}>
//                   <InputControlRow label="2">
//                     <TextBox name='codes-currency-u2' maxLength={20} data-validationfor="blockUnit2" disabled={readonly} value={currency?.u2 || ''} onChange={e => onChange({u2: e.target.value})} />
//                   </InputControlRow>
//                 </div>
//               }
//               right={
//                 <div style={{marginLeft: '10px'}}>
//                   <InputControlRow label="3">
//                     <TextBox name='codes-currency-u3' maxLength={20} data-validationfor="blockUnit3" disabled={readonly} value={currency?.u3 || ''} onChange={e => onChange({u3: e.target.value})} />
//                   </InputControlRow>
//                 </div>
//               }
//             />

//             <LeftRightSplit
//               left={
//                 <div style={{marginRight: '10px'}}>
//                   <InputControlRow label="4">
//                     <TextBox name='codes-currency-u4' maxLength={20} data-validationfor="blockUnit4" disabled={readonly} value={currency?.u4 || ''} onChange={e => onChange({u4: e.target.value})} />
//                   </InputControlRow>
//                 </div>
//               }
//               right={
//                 <div style={{marginLeft: '10px'}}>
//                   <InputControlRow label="5">
//                     <TextBox name='codes-currency-u5' maxLength={20} data-validationfor="blockUnit5" disabled={readonly} value={currency?.u5 || ''} onChange={e => onChange({u5: e.target.value})} />
//                   </InputControlRow>
//                 </div>
//               }
//             />

//             <LeftRightSplit
//               left={
//                 <div style={{marginRight: '10px'}}>
//                   <InputControlRow label="6">
//                     <TextBox name='codes-currency-u6' maxLength={20} data-validationfor="blockUnit6" disabled={readonly} value={currency?.u6 || ''} onChange={e => onChange({u6: e.target.value})} />
//                   </InputControlRow>
//                 </div>
//               }
//               right={
//                 <div style={{marginLeft: '10px'}}>
//                   <InputControlRow label="7">
//                     <TextBox name='codes-currency-u7' maxLength={20} data-validationfor="blockUnit7" disabled={readonly} value={currency?.u7 || ''} onChange={e => onChange({u7: e.target.value})} />
//                   </InputControlRow>
//                 </div>
//               }
//             />

//             <InputControlRow label={
//               <LeftRightSplit
//                 leftSize="30px"
//                 rightSize="calc(100% - 30px)"
//                 left={
//                   <div id='codes-currency-uUseSpace'>
//                     <CheckBox name='codes-currency-uUseSpace' disabled={readonly}  value={currency?.uUseSpace || false} onChange={useSpaceBlockUnit => onChange({uUseSpace: useSpaceBlockUnit})} />
//                   </div>
//                 }
//                 right={
//                   <>Use Space</>
//                 }
//               />
//             }>
//               &nbsp;
//             </InputControlRow>
          
//         </div>

//       </div>

//       <div style={{float: 'left', marginLeft: '10px', width: 'calc(25% - 20px)'}}>
//         <RowSpacer />

//         <LeftRightSplit
//           left={
//             <div style={{marginRight: '10px'}}>
//               <InputControlRow label="0">
//                 <TextBox name='codes-currency-n0' maxLength={20} data-validationfor="numberCharacters0" disabled={readonly} value={currency?.n0 || ''} onChange={e => onChange({n0: e.target.value})} />
//               </InputControlRow>
//             </div>
//           }
//           right={
//             <div style={{marginLeft: '10px'}}>
//               <InputControlRow label="1">
//                 <TextBox name='codes-currency-n1' maxLength={20} data-validationfor="numberCharacters1" disabled={readonly} value={currency?.n1 || ''} onChange={e => onChange({n1: e.target.value})} />
//               </InputControlRow>
//             </div>
//           }
//         />

//         <LeftRightSplit
//           left={
//             <div style={{marginRight: '10px'}}>
//               <InputControlRow label="2">
//                 <TextBox name='codes-currency-n2' maxLength={20} data-validationfor="numberCharacters2" disabled={readonly} value={currency?.n2 || ''} onChange={e => onChange({n2: e.target.value})} />
//               </InputControlRow>
//             </div>
//           }
//           right={
//             <div style={{marginLeft: '10px'}}>
//               <InputControlRow label="3">
//                 <TextBox name='codes-currency-n3' maxLength={20} data-validationfor="numberCharacters3" disabled={readonly} value={currency?.n3 || ''} onChange={e => onChange({n3: e.target.value})} />
//               </InputControlRow>
//             </div>
//           }
//         />

//         <LeftRightSplit
//           left={
//             <div style={{marginRight: '10px'}}>
//               <InputControlRow label="4">
//                 <TextBox name='codes-currency-n4' maxLength={20} data-validationfor="numberCharacters4" disabled={readonly} value={currency?.n4 || ''} onChange={e => onChange({n4: e.target.value})} />
//               </InputControlRow>
//             </div>
//           }
//           right={
//             <div style={{marginLeft: '10px'}}>
//               <InputControlRow label="5">
//                 <TextBox name='codes-currency-n5' maxLength={20} data-validationfor="numberCharacters5" disabled={readonly} value={currency?.n5 || ''} onChange={e => onChange({n5: e.target.value})} />
//               </InputControlRow>
//             </div>
//           }
//         />

        // <LeftRightSplit
        //   left={
        //     <div style={{marginRight: '10px'}}>
        //       <InputControlRow label="6">
        //         <TextBox name='codes-currency-n6' maxLength={20} data-validationfor="numberCharacters5" disabled={readonly} value={currency?.n6 || ''} onChange={e => onChange({n6: e.target.value})} />
        //       </InputControlRow>
        //     </div>
        //   }
        //   right={
        //     <div style={{marginLeft: '10px'}}>
        //       <InputControlRow label="7">
        //         <TextBox name='codes-currency-n7' maxLength={20} data-validationfor="numberCharacters6" disabled={readonly} value={currency?.n7 || ''} onChange={e => onChange({n7: e.target.value})} />
        //       </InputControlRow>
        //     </div>
        //   }
        // />

//         <LeftRightSplit
//           left={
//             <div style={{marginRight: '10px'}}>
//               <InputControlRow label="8">
//                 <TextBox name='codes-currency-n8' maxLength={20} data-validationfor="numberCharacters8" disabled={readonly} value={currency?.n8 || ''} onChange={e => onChange({n8: e.target.value})} />
//               </InputControlRow>
//             </div>
//           }
//           right={
//             <div style={{marginLeft: '10px'}}>
//               <InputControlRow label="9">
//                 <TextBox name='codes-currency-n9' maxLength={20} data-validationfor="numberCharacters9" disabled={readonly} value={currency?.n9 || ''} onChange={e => onChange({n9: e.target.value})} />
//               </InputControlRow>
//             </div>
//           }
//         />

//         <LeftRightSplit
//           left={
//             <div style={{marginRight: '10px'}}>
//               <InputControlRow label="10">
//                 <TextBox name='codes-currency-n10' maxLength={20} data-validationfor="numberCharacters10" disabled={readonly} value={currency?.n10 || ''} onChange={e => onChange({n10: e.target.value})} />
//               </InputControlRow>
//             </div>
//           }
//           right={
//             <div style={{marginLeft: '10px'}}>
//               <InputControlRow label="11">
//                 <TextBox name='codes-currency-n11' maxLength={20} data-validationfor="numberCharacters11" disabled={readonly} value={currency?.n11 || ''} onChange={e => onChange({n11: e.target.value})} />
//               </InputControlRow>
//             </div>
//           }
//         />

//         <LeftRightSplit
//           left={
//             <div style={{marginRight: '10px'}}>
//               <InputControlRow label="12">
//                 <TextBox name='codes-currency-n12' maxLength={20} data-validationfor="numberCharacters12" disabled={readonly} value={currency?.n12 || ''} onChange={e => onChange({n12: e.target.value})} />
//               </InputControlRow>
//             </div>
//           }
//           right={
//             <div style={{marginLeft: '10px'}}>
//               <InputControlRow label="13">
//                 <TextBox name='codes-currency-n13' maxLength={20} data-validationfor="numberCharacters13" disabled={readonly} value={currency?.n13 || ''} onChange={e => onChange({n13: e.target.value})} />
//               </InputControlRow>
//             </div>
//           }
//         />

//         <LeftRightSplit
//           left={
//             <div style={{marginRight: '10px'}}>
//               <InputControlRow label="14">
//                 <TextBox name='codes-currency-n14' maxLength={20} data-validationfor="numberCharacters14" disabled={readonly} value={currency?.n14 || ''} onChange={e => onChange({n14: e.target.value})} />
//               </InputControlRow>
//             </div>
//           }
//           right={
//             <div style={{marginLeft: '10px'}}>
//               <InputControlRow label="15">
//                 <TextBox name='codes-currency-n15' maxLength={20} data-validationfor="numberCharacters15" disabled={readonly} value={currency?.n15 || ''} onChange={e => onChange({n15: e.target.value})} />
//               </InputControlRow>
//             </div>
//           }
//         />

//         <LeftRightSplit
//           left={
//             <div style={{marginRight: '10px'}}>
//               <InputControlRow label="16">
//                 <TextBox name='codes-currency-n16' maxLength={20} data-validationfor="numberCharacters16" disabled={readonly} value={currency?.n16 || ''} onChange={e => onChange({n16: e.target.value})} />
//               </InputControlRow>
//             </div>
//           }
//           right={
//             <div style={{marginLeft: '10px'}}>
//               <InputControlRow label="17">
//                 <TextBox name='codes-currency-n17' maxLength={20} data-validationfor="numberCharacters17" disabled={readonly} value={currency?.n17 || ''} onChange={e => onChange({n17: e.target.value})} />
//               </InputControlRow>
//             </div>
//           }
//         />

//         <LeftRightSplit
//           left={
//             <div style={{marginRight: '10px'}}>
//               <InputControlRow label="18">
//                 <TextBox name='codes-currency-n18' maxLength={20} data-validationfor="numberCharacters18" disabled={readonly} value={currency?.n18 || ''} onChange={e => onChange({n18: e.target.value})} />
//               </InputControlRow>
//             </div>
//           }
//           right={
//             <div style={{marginLeft: '10px'}}>
//               <InputControlRow label="19">
//                 <TextBox name='codes-currency-n19' maxLength={20} data-validationfor="numberCharacters19" disabled={readonly} value={currency?.n19 || ''} onChange={e => onChange({n19: e.target.value})} />
//               </InputControlRow>
//             </div>
//           }
//         />

//         <LeftRightSplit
//           left={
//             <div style={{marginRight: '10px'}}>
//               <InputControlRow label="20">
//                 <TextBox name='codes-currency-n20' maxLength={20} data-validationfor="numberCharacters20" disabled={readonly} value={currency?.n20 || ''} onChange={e => onChange({n20: e.target.value})} />
//               </InputControlRow>
//             </div>
//           }
//           right={
//             <div style={{marginLeft: '10px'}}>
//               <InputControlRow label="30">
//                 <TextBox name='codes-currency-n30' maxLength={20} data-validationfor="numberCharacters30" disabled={readonly} value={currency?.n30 || ''} onChange={e => onChange({n30: e.target.value})} />
//               </InputControlRow>
//             </div>
//           }
//         />

//         <LeftRightSplit
//           left={
//             <div style={{marginRight: '10px'}}>
//               <InputControlRow label="40">
//                 <TextBox name='codes-currency-n40' maxLength={20} data-validationfor="numberCharacters40" disabled={readonly} value={currency?.n40 || ''} onChange={e => onChange({n40: e.target.value})} />
//               </InputControlRow>
//             </div>
//           }
//           right={
//             <div style={{marginLeft: '10px'}}>
//               <InputControlRow label="50">
//                 <TextBox name='codes-currency-n50' maxLength={20} data-validationfor="numberCharacters50" disabled={readonly} value={currency?.n50 || ''} onChange={e => onChange({n50: e.target.value})} />
//               </InputControlRow>
//             </div>
//           }
//         />

//         <LeftRightSplit
//           left={
//             <div style={{marginRight: '10px'}}>
//               <InputControlRow label="60">
//                 <TextBox name='codes-currency-n60' maxLength={20} data-validationfor="numberCharacters60" disabled={readonly} value={currency?.n60 || ''} onChange={e => onChange({n60: e.target.value})} />
//               </InputControlRow>
//             </div>
//           }
//           right={
//             <div style={{marginLeft: '10px'}}>
//               <InputControlRow label="70">
//                 <TextBox name='codes-currency-n70' maxLength={20} data-validationfor="numberCharacters70" disabled={readonly} value={currency?.n70 || ''} onChange={e => onChange({n70: e.target.value})} />
//               </InputControlRow>
//             </div>
//           }
//         />

//         <LeftRightSplit
//           left={
//             <div style={{marginRight: '10px'}}>
//               <InputControlRow label="80">
//                 <TextBox name='codes-currency-n80' maxLength={20} data-validationfor="numberCharacters80" disabled={readonly} value={currency?.n80 || ''} onChange={e => onChange({n80: e.target.value})} />
//               </InputControlRow>
//             </div>
//           }
//           right={
//             <div style={{marginLeft: '10px'}}>
//               <InputControlRow label="90">
//                 <TextBox name='codes-currency-n90' maxLength={20} data-validationfor="numberCharacters90" disabled={readonly} value={currency?.n90 || ''} onChange={e => onChange({n90: e.target.value})}
//                     onTabNext={() => {
//                       if (currency && currency.id > 0)
//                         document.getElementById('currency-inactive')?.focus();
//                       else
//                         document.getElementById('currency-code')?.focus();
//                       return true;
//                     }} />
//               </InputControlRow>
//             </div>
//           }
//         />
//       </div>


//     </div>
//   );

//   function cmTest(){
//     let result = '';
//     if(currency.xSize === 0) result = "Please enter base unit size"
//     else if (!testAmount || testAmount === 0) result = "Please enter amount";
//     else result = numberToWords(testAmount);
    
//     showGlobalOkDialog(<p>{result}</p>);
//   }

//   function numberToWords(vAmount: number, vMaxWidth: number = 50) {

//     let i;
//     let j;
//     let iPos;
//     let t_bHundredMode;
//     let t_nDollarAmount;
//     let t_nCentAmount;
//     let t_nCurrentValue = 0;
//     let t_nCurrentSubValue;
//     let t_sProcessXNumbers;
//     let t_nMax;
//     let t_sXNumbers;
//     let t_sCurrentWords = "";
//     let t_sCurrentLine = "";
//     let result = "";             // t_sRet
//     let t_bXLast;
//     let t_nProcessLen;
//     let t_sTemp;

//     let t_nXSize;    // Basic Number Size
//     let t_nCSize;    // Cents Size
//     let t_sHundred_Sep;     // Hundred Separate Symbo (-)
//     let t_sDollarCent_Sep;     // Dollar and Cent (and)
//     let t_sBlock_Sep;          // Block (and)
//     let t_sSuffix;     // Last Suffix Words  : '원정' 에서 '정'
//     let t_sCentName;     // 
//     let t_bCentsIsNumeric;     // ''=Cents convert to Words, 'N'=Cents display numeric
//     let t_sZeroCent;     // Last Suffix Words  : '원정' 에서 '정'

//     let t_bUseSpace_X;
//     let t_bUseSpace_U;
//     let t_bUseSpace_B;
//     let t_bUseMiddleXWords;   // // Use middle zero words
//     let t_bNoUseSuffixWhen;   // // No use suffix when the lowest basic unit was used

//     let t_bIsHaveLowestUnit = false;  // // lowest unit 사용 여부
//     let t_bIsHaveMiddleZero = false;  // // Middle zero 여부

//     t_nXSize = currency?.xSize;

//     t_nCSize = currency?.decimal;
//     t_sCentName = currency?.centName;
//     t_bCentsIsNumeric = currency.cMode === 'N';
//     t_sZeroCent = currency?.zeroCent;
//     t_bHundredMode = currency?.useHundred || false;
//     t_sHundred_Sep = currency?.hundred_Sep;
//     t_sDollarCent_Sep = currency?.sepWords;
//     t_sBlock_Sep = currency?.commaWords;
//     t_sSuffix = currency?.suffix;
//     t_bUseSpace_X = currency?.xUseSpace || false;
//     t_bUseSpace_U = currency?.uUseSpace || false;
//     t_bUseSpace_B = currency?.bUseSpace || false;
//     t_bUseMiddleXWords = currency?.useMiddleZWords || false;
//     t_bNoUseSuffixWhen = currency?.noUseSuffixWhen || false;

//     if (t_sHundred_Sep.length === 0) {
//       t_sHundred_Sep = " ";
//     }

//     let t_sXDName: Array<string> = [];
//     let t_sXName: Array<string> = [];
//     let t_sUName: Array<string> = [];
//     let t_sNName: Array<string> = [];

//     t_sXDName.push("");
//     t_sXDName.push(currency?.xD2);
//     t_sXDName.push(currency?.xD1);

//     t_sXName.push(currency?.x0);
//     t_sXName.push(currency?.x1);
//     t_sXName.push(currency?.x2);
//     t_sXName.push(currency?.x3);
//     t_sXName.push(currency?.x4);
//     t_sXName.push(currency?.x5);

//     t_sUName.push(currency?.u0);
//     t_sUName.push(currency?.u1);
//     t_sUName.push(currency?.u2);
//     t_sUName.push(currency?.u3);
//     t_sUName.push(currency?.u4);
//     t_sUName.push(currency?.u5);
//     t_sUName.push(currency?.u6);
//     t_sUName.push(currency?.u7);

//     t_sNName.push(currency?.n0);
//     t_sNName.push(currency?.n1);
//     t_sNName.push(currency?.n2);
//     t_sNName.push(currency?.n3);
//     t_sNName.push(currency?.n4);
//     t_sNName.push(currency?.n5);
//     t_sNName.push(currency?.n6);
//     t_sNName.push(currency?.n7);
//     t_sNName.push(currency?.n8);
//     t_sNName.push(currency?.n9);
//     t_sNName.push(currency?.n10);
//     t_sNName.push(currency?.n11);
//     t_sNName.push(currency?.n12);
//     t_sNName.push(currency?.n13);
//     t_sNName.push(currency?.n14);
//     t_sNName.push(currency?.n15);
//     t_sNName.push(currency?.n16);
//     t_sNName.push(currency?.n17);
//     t_sNName.push(currency?.n18);
//     t_sNName.push(currency?.n19);
//     t_sNName.push(currency?.n20);
//     t_sNName.push(currency?.n30);
//     t_sNName.push(currency?.n40);
//     t_sNName.push(currency?.n50);
//     t_sNName.push(currency?.n60);
//     t_sNName.push(currency?.n70);
//     t_sNName.push(currency?.n80);
//     t_sNName.push(currency?.n90);

//     t_nDollarAmount = Math.trunc(vAmount);
//     t_nCentAmount = Math.trunc(round(vAmount - t_nDollarAmount, 2) * Math.pow(10, t_nCSize))
//     t_sProcessXNumbers = t_nDollarAmount.toString();
//     t_nMax = Math.trunc((t_sProcessXNumbers.length - 1) / t_nXSize);
//     t_nProcessLen = t_sProcessXNumbers.length % t_nXSize;

//     if (t_nProcessLen === 0)
//       t_nProcessLen = t_nXSize;

//     for (i = t_nMax; i >= 0; i += -1) {

//       t_sXNumbers = t_sProcessXNumbers.substring(0, t_nProcessLen);
//       t_sProcessXNumbers = t_sProcessXNumbers.substring(t_nProcessLen + 1 - 1);
//       t_nProcessLen = t_nXSize;
//       iPos = 0;
//       t_bXLast = false;
//       t_sCurrentLine = "";

//       for (j = t_sXNumbers.length; j >= 1; j += -1) {

//         iPos = iPos + 1;

//         t_bXLast = (t_bHundredMode && j === 2) || (j === 1);

//         if (t_bXLast) {
//           j = 1;
//           t_nCurrentValue = parseInt(t_sXNumbers.substring(iPos - 1));

//         } else {
//           t_nCurrentValue = parseInt(t_sXNumbers.substring(iPos - 1, 1));
//         }

//         // Select Case t_nCurrentValue
//         if (t_nCurrentValue === 0) {
//           t_sCurrentWords = "";
//           t_bIsHaveMiddleZero = true;
//         }
//         else if (t_nCurrentValue >= 1 && t_nCurrentValue <= 20) {
//           if (t_bUseMiddleXWords && t_bIsHaveMiddleZero) {
//             t_sCurrentWords = t_sNName[0];
//             t_bIsHaveMiddleZero = false;
//           }
//           else
//             t_sCurrentWords = "";

//           t_sCurrentWords = t_sCurrentWords + t_sNName[t_nCurrentValue];
//         }
//         else if (t_nCurrentValue >= 21 && t_nCurrentValue <= 99) {
//           if (t_bUseMiddleXWords && t_bIsHaveMiddleZero) {
//             t_sCurrentWords = t_sNName[0];
//             t_bIsHaveMiddleZero = false;
//           }
//           else
//             t_sCurrentWords = "";


//           t_nCurrentSubValue = parseInt(t_sXNumbers.substring(t_sXNumbers.length - 1, t_sXNumbers.length));
//           t_sCurrentWords = t_sCurrentWords + t_sNName[Math.floor((t_nCurrentValue / 10) + 18)] + t_sHundred_Sep + t_sNName[t_nCurrentSubValue];
//         }

//         if (t_sXName.length >= j && !_.isEmpty(t_sXName[j - 1]) && !_.isEmpty(t_sCurrentWords))
//           t_sCurrentWords = t_sCurrentWords + (t_bUseSpace_X ? " " : "") + t_sXName[j - 1]; // Two Hundred
      
//        t_sCurrentLine = t_sCurrentLine + (!(_.isEmpty(t_sCurrentLine) && !_.isEmpty(t_sCurrentWords ) && t_bUseSpace_X) ? " " : "") + t_sCurrentWords;

//       }

//       if (t_nMax === 0 && t_sCurrentLine === null)
//         t_sCurrentLine = t_sNName[0]; // Zero (Dollar)

//       if (!_.isEmpty(t_sCurrentLine)) {
//         t_sCurrentLine = t_sCurrentLine + ((!_.isEmpty(t_sUName[i]) && t_bUseSpace_U) ? " " : "") + t_sUName[i]; // Millon / Thousand / Dollar

//         if (!_.isEmpty(t_sBlock_Sep) && i !== t_nMax)
//           t_sCurrentLine = t_sBlock_Sep + (t_bUseSpace_B ? " " : "") + t_sCurrentLine;

//         t_sTemp = (t_bUseSpace_B && !_.isEmpty(result)) ? " " : "";
//         if (isOverLineMaxChars(result + t_sTemp + t_sCurrentLine, vMaxWidth))
//           result = result + "\r\n" + t_sCurrentLine;
//         else
//           result = result + t_sTemp + t_sCurrentLine;
//       }

//     }

//     t_sCurrentLine = "";

//     if (t_nCSize > 0) {

//       if (t_bCentsIsNumeric) {
//         if (t_nCentAmount === 0) {
//           if (!_.isEmpty(t_sCentName)) {

//             if (!_.isEmpty(t_sZeroCent))
//               t_sCurrentLine = t_sZeroCent;
//             else
//               t_sCurrentLine = "".padStart(t_nCSize, '0');
//           }
//         }
//         else
//           t_sCurrentLine = t_nCentAmount.toString();
//         if (!_.isEmpty(t_sCentName))
//           t_sCurrentLine = t_sCurrentLine + t_sCentName;
//       }
//       else {
//         t_sXNumbers = t_nCentAmount.toString();
//         iPos = 0;
//         t_bXLast = false;

//         for (j = t_sXNumbers.length; j >= 1; j += -1) {
//           iPos = iPos + 1;

//           t_bXLast = (t_bHundredMode && j === 2) || (j === 1);

//           if (t_bXLast) {
//             j = 1;
//             t_nCurrentValue = parseInt(t_sXNumbers.substring(iPos - 1));
//             if (t_nCurrentValue !== 0)
//               t_bIsHaveLowestUnit = true; // // Lowest Unit 사용여부
//           }
//           else
//             t_nCurrentValue = parseInt(t_sXNumbers.substring(iPos - 1, 1));

//           // Select Case t_nCurrentValue
//           if (t_nCurrentValue === 0)
//             t_sCurrentWords = "";
//           else if (t_nCurrentValue >= 1 && t_nCurrentValue <= 20)
//             t_sCurrentWords = t_sNName[t_nCurrentValue];
//           else if (t_nCurrentValue >= 21 && t_nCurrentValue <= 99) {
//             t_nCurrentSubValue = parseInt(t_sXNumbers.substring(t_sXNumbers.length - 1, t_sXNumbers.length));
//             t_sCurrentWords = t_sNName[Math.floor((t_nCurrentValue / 10) + 18)] + t_sHundred_Sep + t_sNName[t_nCurrentSubValue];
//           }


//           if (!_.isEmpty(t_sXDName[j]) && !_.isEmpty(t_sCurrentWords))
//             t_sCurrentWords = t_sCurrentWords + (t_bUseSpace_X ? " " : "") + t_sXDName[j]; // Two Hundred

//           t_sCurrentLine = t_sCurrentLine + ((!_.isEmpty(t_sCurrentLine) && !_.isEmpty(t_sCurrentWords) && t_bUseSpace_X) ? " " : "") + t_sCurrentWords;

//         }

//         if (result === null && t_sCurrentLine === null)
//           t_sCurrentLine = t_sNName[0]; // Zero (Cent)

//         if (!_.isEmpty(t_sCentName))
//           t_sCurrentLine = t_sCurrentLine + t_sCentName; // Cent
//       }

//       if (!_.isEmpty(t_sDollarCent_Sep) && !_.isEmpty(t_sCurrentLine))
//         t_sCurrentLine = t_sDollarCent_Sep + " " + t_sCurrentLine;

//       t_sTemp = (t_bUseSpace_B && !_.isEmpty(result)) ? " " : "";

//       if (isOverLineMaxChars(result + t_sTemp + t_sCurrentLine, vMaxWidth))
//         result = result + "\r\n" + t_sCurrentLine;
//       else
//         result = result + t_sTemp + t_sCurrentLine;

//     }


//     if (result.length > 0 && t_sSuffix.length > 0) {
//       if (!(t_bNoUseSuffixWhen && t_bIsHaveLowestUnit))
//         result = result + t_sSuffix;
//     }

//     return result;

//   }

//   function isOverLineMaxChars(vSource:string, vMaxLen:number){

//     let tCurLen;

//     let iPos = vSource.lastIndexOf('\n');
//     if (iPos > 0)
//         tCurLen = vSource.length - iPos;
//     else
//         tCurLen = vSource.length;

//     return (tCurLen > vMaxLen);

//   }

// }

class EditableCodeCurrencyInfoListItem extends CodeCurrencyListItem {
  isNew: boolean = false;
  isDelete: boolean = false;
  isUpdate: boolean = false;
  decimal: number = 0;
}

function formatElement(data: any, index: number) {
  //return {...data, indicator: index + 1};

  const result = new EditableCodeCurrencyInfoListItem();
  result.indicator = index + 1;
  result.code = data.code;
  result.decimal = data.decimal;
  result.symbol = data.symbol;
  result.localSymbol = data.localSymbol;
  result.inactive = data.inactive;

  result.cid = data.cid;
  result.cid2 = data.cid2;
  result.isNew = false;
  result.isDelete = false;

  return result;
}

function formatData(data: Array<any>) {
  return data.map((d, i) => formatElement(d, i));
}

function CodeRenderer({ data, row }: any) {
  const changeLineItem = data[0].changeLineItem;
  const l = data[row.index];
  return (
    <div style={{marginTop: '0px'}}>
      <TextBox maxLength={3} textId={`ifms-currency-${row.index}`} value={l.code} onChange={(e) => {
        changeLineItem(row.index, { code: e.target.value, isUpdate: true })
        }} />
    </div>
  );
}

function DecimalRenderer({ data, row }: any) {
const changeLineItem = data[0].changeLineItem;
const l = data[row.index];
return (
  <div style={{marginTop: '0px'}}>
    <Number maxLength={1} textId={`ifms-decimal-${row.index}`} value={l.decimal} onChange={(decimal) => {
      changeLineItem(row.index, { decimal, isUpdate: true })
      }} />
  </div>
);
}

function SymbolRenderer({ data, row }: any) {
const changeLineItem = data[0].changeLineItem;
const l = data[row.index];
return (
  <div style={{marginTop: '0px'}}>
    <TextBox maxLength={6} textId={`ifms-symbol-${row.index}`} value={l.symbol} onChange={(e) => {
       changeLineItem(row.index, { symbol: e.target.value, isUpdate: true })
      }}
    />
  </div>
);
}

function LocalSymbolRenderer({ data, row }: any) {
const changeLineItem = data[0].changeLineItem;
const l = data[row.index];
return (
<div style={{marginTop: '0px'}}>
  <TextBox maxLength={6} textId={`ifms-localSymbol-${row.index}`} value={l.localSymbol} onChange={(e) => {
     changeLineItem(row.index, { localSymbol: e.target.value, isUpdate: true })
    }}
  />
</div>
);
}

function CurrencyCodes({
  componentIndex
}: {
  componentIndex: number
}) {
  useFunction({invokers: {
    ifmsSettingsSave: save,
    ifmsSettingsCancel: cancelOperation,
  }});
  useFunctionKeys({ onEsc: cancelOperation, onSave: handleSaveAndClose });

  const appContext = useContext(ApplicationContext);
  const refContext = useContext(IFmsReferenceFilesContext);
  const [showGlobalOkDialog] = useGlobalOkDialog();
  // const {selectTableRow, tableNavigationCleanup } = useTableNavigation('codes-currency-list', onRowSelect, onRowDoubleSelect, ['code'], false, false, false);

  const savedDataRef = useRef<Array<CodeCurrencyListItem>>([]);
  const oriData = useRef<CodeCurrencyListItem[]>([]);
  
  const [loading, setLoading] = useState(false);
  const [hasChanges, setHasChanges] = useFastStorage(`ifms-referenceFiles-haschanges`, false);
  const [data, _setData, removeData, dataRef] = useFastStorage(`ifms-referenceFiles-currency-list`, []);
  
  //<pt220818: portal>
  //const { setCleanState, dirtyCleanup} = useDirtyCheck(`ifms-referenceFiles-currency-editable`, ['edit', 'view']);
  const listSec = findSecurityTask(appContext, FmsSecTask.CodeCurrency);
  //const [selectedRow, setSelectedRow] = useState(-1);

  const [orderBy, setOrderBy] = useTypedFastStorage<ListOrderBy>(`ifms-referenceFiles-currency-code-orderby`, getDefaultOrderBy());

  //const hasSelectedRow = !isNaN(selectedRow) && !(selectedRow < 0);
  const canBeAdd = listSec?.grantAdd;
  //const canBeEdit = hasSelectedRow && listSec?.grantEdit;
  //const canBeDeleted = hasSelectedRow && listSec?.grantDel;

  const tableHeight = 520;
  const listItemType = 'CodeCurrencyListItem';

  // function setCurrency(c:Partial<NCodeCurrency>, skipDirty:boolean = false) {
  //   if (!skipDirty) {
  //     setHasChanges(true);
  //   }
  //   _setCurrency(c);
  // }

  const [focusFirstCell, setFocusFirstCell] = useState({ dataLength: 0, focus: false });
  const { FilterButton, search } = useFilterBar(
    codesCurrencyList,
    undefined,
    getDefaultOrderBy(), 
    String(componentIndex),
    false,
    undefined,
    undefined,
    setOrderBy,
  );

  function handleSaveAndClose() {
    const saveBtn = document.getElementById('detail-save-button');
    if (saveBtn) {
      saveBtn.focus();
      const modals = document.querySelector('[class^="ReactModal__Content"]');
      if (!modals)
        saveBtn.click();
    }
  }

  function getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'id',
      orderByAscending: false,
    };
  }

  function setData(d:Array<any>, callByFetchData: boolean = false) {
    setFocusFirstCell({ dataLength: d.length, focus: callByFetchData });
    _setData(d, null, { forceClone: callByFetchData });
    setHasChanges(checkTabIsDirty(CodeCurrencyListItem, oriData.current, d));
  }

  async function fetchData(api: any, clearHeaderOrder: boolean) {
    if (clearHeaderOrder && isFilterObjectEmpty(search)) {
      setOrderBy(getDefaultOrderBy());
    } else if (search.orderBy) {
      setOrderBy({ orderBy: search.orderBy, orderByAscending: search.orderByAscending });
    }
    
    setLoading(true);

    const apiResult = await api.getListItems(JobNames.Currency,
      listItemType,
      CodeCurrencyListItem.calculateSearchParameters(search,CodeCurrencyListItem.MapSearchFields), 1, search.pageSize);
    const data = apiResult && apiResult.entities ? apiResult.entities : [];
    setData(formatData(data), true);

    setHasChanges(false);
    setLoading(false);
  }

  async function reload(clearAll:boolean = true) {
    await fetchData(appContext.api, clearAll);
  }

  function addLineItem() {
    const newRow = new EditableCodeCurrencyInfoListItem();
    newRow.isNew = true;

    return {
      setDataFunc: (list: any) => setData(list),
      curListData: data,
      newData: newRow
    };
  }

   function applyToLineItem(rowIndex: number, change: Partial<EditableCodeCurrencyInfoListItem> | null) {
    if (!change || !data) {
       return;
     }
     const newData = [...data];
     const checkData = data[rowIndex];
     if (!change.isNew && (change.code !== checkData.code || change.decimal !== checkData.decimal || change.symbol !== checkData.symbol || change.localSymbol !== checkData.localSymbol || change.inactive !== checkData.inactive)) {
       _.merge(newData[rowIndex], { ...change, hasBeenChanged: true });
       setData(newData);
       //setHasChanges(true);
     }
   }

   

  function deleteEntity(index: number): boolean {
    if (!data){
      return false;
    }

    const element = data[index];
    if (!element.isNew) {
      let deleteRow = savedDataRef.current.find(x => x.code === element.code && x.symbol === element.symbol);
      if (deleteRow) {
        deleteRow.isDelete = true;
      }
    }
    data.splice(index, 1);
    setData(data);

    return true;
  }

  // function selectCurrencyForNew() {
  //   const newCodeModel = new NCodeCurrency();   
  //   setCurrency(newCodeModel, false);
  //   setCleanState(newCodeModel);
  // }

  // async function selectCurrencyForEdit(){
   
  //   await setCurrencyCodeDetail(false);
  // }

  // async function selectCurrencyForView(){
   
  //   await setCurrencyCodeDetail(true);
  // }

  // async function selectCurrencyForDelete(){
  //   const doConfirm = await showGlobalYesNoDialog(
  //     <div>
  //       <h3>Confirm to Delete?</h3>
  //     </div>
  //   );
  //   if(doConfirm){
  //     const apiResult = await appContext.api.deleteJobDetail(JobNames.Currency, { id:dataRef.current[selectedRow].id , pimsLinkId: 0 });
  //     if (apiResult && apiResult.success) {
  //       reload();
  //     }else
  //     showGlobalOkDialog(<p>{"Cannot delete"}</p>);
  //   }else
  //   return;
  // }


  function cancelOperation() {
    setHasChanges(false);
    removeData();
    // clearTableSelection();
    //removeCurrencyFromStorage();
    return true;
  }

  async function validCurrencyData(data: any) {
    let errorMsg1 = '';
    let errorMsg2 = '';
  
    data.forEach((item: any) => {
      if (!item.code) {
        errorMsg1 = appendLine(errorMsg1, "  * Must enter Currency Code");
      }
  
      //const decimalValue = parseInt(String(item.decimal), 10);
      if (item.decimal < 0 || item.decimal > 4) {
        errorMsg2 = appendLine(errorMsg2, "  * Must enter only numbers between 0 and 4 - Decimal Digits");
    }});

    if (errorMsg1) {
      await showGlobalOkDialog(<p>{errorMsg1}</p>);
      return false;
    } 
    
    if (errorMsg2) {
      await showGlobalOkDialog(<p>{errorMsg2}</p>);
      return false;
    }

    return true;
  }

  async function save() {
    //if (!currency) return;
    if (!data) return;

    const isValid = await validCurrencyData(data);
    if (!isValid) return;
    
    let validData = dataRef.current.filter((x: any) => x.code);
    let errMsg = '';
    const dataToSave = validData.filter((x: any) => x.isNew || x.hasBeenChanged === true);
    const dataToDelete = savedDataRef.current.filter((x) => x.isDelete);
    if(dataToSave.length === 0 && dataToDelete.length === 0) {
      if (hasChanges) reload(false);
      return;
    }
    setLoading(true);

    for (let i = 0; i < dataToDelete.length; ++i) {
      const s = dataToDelete[i];
      const apiResult:ApiResult<InsertResult> = await appContext.api.saveListItem(listItemType, SQLType.Delete, _.omit(s, ['isDelete']));
      if (!apiResult || !apiResult.success) {
        errMsg = apiResult?.message ?? constants.SAVE_ERROR_MESSAGE;
      }
    }

    if (dataToSave.length > 0) {
      const isDuplicate = await duplicateCell(dataToSave, data, appContext, listItemType, showGlobalOkDialog, JobNames.Currency, 'code', 'symbol');
      if (isDuplicate) {
        setLoading(false);
        return;
      }

    const apiResult:ApiResult<InsertResult> = await appContext.api.saveList(listItemType, dataToSave);
    if (!apiResult || !apiResult.success) {
      errMsg += (errMsg ? '\n' : '' ) + (apiResult?.message ?? constants.SAVE_ERROR_MESSAGE);
    } else {
      dataToSave.forEach((x: any) => {
        const index = data.findIndex((d: any) => d.code === x.code && d.symbol === x.symbol);
        if (index >= 0) {
          data[index].cid = x.code;
          data[index].cid2 = x.symbol;
          data[index].hasBeenChanged = false;
        }
        if (x.isNew) {
          delete data[index].isNew;
        }
      })
    }
  }

  if (isValid) {
    // <chuck date="2025-01-07" github="1791" desc="Currency 코드가 변경되면 바로 systemSettings.currencies 에 반영되게 수정.">
    let currencies: Currency[] = [];
    
    data.forEach((item: any) => {
      currencies.push({
        id: item.id,
        currency: item.code,
        decimal: item.decimal,
        localSymbol: item.localSymbol,
        symbol: item.symbol,
        inactive: item.inactive
      })
    });
    // </chuck>

    appContext.setSystemSettings({...appContext.systemSettings, currencies });

    reload(false);
    await showGlobalOkDialog(<p>The data has been saved</p>);
  }

  // View가 있던 기존 로직
  // let errorMsg1 = '';
  // let errorMsg2 = '';

  // if (currency.code === "") {
  //   errorMsg2 = appendLine(errorMsg2, "  * Must enter Currency Code");
  // }
  // if (currency.decimal < 0 || currency.decimal > 4) {
  //   errorMsg2 = appendLine(errorMsg2, "  * Must enter only numbers between 0 and 4 - Decimal Digits");
  // }
  // if (await appContext.api.checkupDuplicateFieldValueIsDuplicate("T_Ncodecurrency", "F_CODE", currency?.code, "F_ID", currency?.id)) {
  //   errorMsg1 = appendLine(errorMsg1, "  * Duplicate Currency Code");
  // }

  // if (errorMsg1 || errorMsg2) {
  //   if (errorMsg2) {
  //     // Critical
  //     await showGlobalOkDialog(<p>Please check following information. (Specify the missing entries.)<br />
  //       {appendLine(errorMsg2, errorMsg1)}
  //     </p>)
  //     return false;
  //   } else {
  //     // Warning
  //     const confirm = await showGlobalYesNoDialog(<p>Please check following information. (Do you want to save?)<br />
  //       {errorMsg1}
  //     </p>)
  //     if (!confirm) return false;
  //   }
  // }

  // const tEntity = new NCodeCurrency(currency);
  // tEntity.trackable = true;
  // setCurrency(tEntity, false);

  // if (!(currency as TrackableEntity).isDirty) {
  //   cancelOperation();
  //   reload();
  //   return;
  // }
  // const sqlInfoList = getSQLInfoList(currency as TrackableEntity);
  // const apiResult: ApiResult<InsertResultsWithData> = await appContext.api.saveJobDetail(JobNames.Currency,
  //   sqlInfoList);

  // if(!apiResult || !apiResult.success) {
  //   await showGlobalOkDialog(<p>{apiResult?.message ?? constants.SAVE_ERROR_MESSAGE}</p>);
  //   return;
  // }
  // else {
  //   await showGlobalOkDialog(<p>The data has been saved</p>);

  //   if(apiResult.result && apiResult.result.insertList){
  //     const insresult = apiResult.result.insertList.find(x => x.model === 'NCodeCurrency');
  //     if (insresult) {
  //       const newItem: any = {
  //         id: insresult.newId,
  //         code: currency.code,
  //         symbol: currency.symbol,
  //         decimal: currency.decimal,
  //         localSymbol: currency.lSymbol,
  //         inactive: currency.inactive
  //       };
  //       const newList = _.cloneDeep(data)
  //       newList.splice(0, 0, newItem);
  //       setData(formatData(newList));
  //     }
  //   } else {
  //     const editItem = data.find((x: any) => x.id === currency.id);
  //     editItem.code = currency.code;
  //     editItem.symbol = currency.symbol;
  //     editItem.decimal = currency.decimal;
  //     editItem.localSymbol = currency.lSymbol;
  //     editItem.inactive = currency.inactive;

  //     const insIndex = data.findIndex((x:any) => x.id === currency.id);
  //     const newList = _.cloneDeep(data);
  //     newList.splice(insIndex, 1, editItem);
  //     setData(formatData(newList));
  //   }
  // }

  //cancelOperation();
  //dirtyCleanup();

  //reload
  //appContext.refreshSystemSettings();
  }

  function onHeaderClick(header: any) {
    if (!orderBy || !orderBy.orderBy) return;

    if (header && header.id !== 'indicator') {
      if (header.id === orderBy.orderBy) {
        setOrderBy({ orderByAscending: !orderBy.orderByAscending });
      } else {
        setOrderBy({ orderBy: header.id, orderByAscending: true });
      }
      
    removeData();
    sortingListData(CodeCurrencyListItem, data, setData, orderBy);
    }
  }

  function cellValueChanged(rowIndex: number, accessor: string, value: any) {
    switch (accessor) {
      case 'inactive':
        applyToLineItem(rowIndex, { inactive: value });
        break;
    }
  }

  const currencyTableOptions:ApplicableTableSettings = {
    customTableId: 'codes-currency-list',
    selectable: false,
    tableName: 'currencyList',
    ...codesCurrencyList,
    height: `${tableHeight}px`,
    data: data.map((x: any, i: number) => ({ ...x, indicator: (i + 1).toString(), changeLineItem: applyToLineItem })),
    rowRenderers: [
      { accessor: 'indicator', nonSelectable: true },
      { accessor: 'code', EditCell: CodeRenderer },
      { accessor: 'decimal', EditCell: DecimalRenderer },
      { accessor: 'symbol', EditCell: SymbolRenderer },
      { accessor: 'localSymbol', EditCell: LocalSymbolRenderer },
      { accessor: 'inactive' },
    ],
    getCellData: (accessor: any, rowData: any, rowIndex: number): CellData | undefined => {
      if (accessor === 'code')
        return { type: TableCellTypes.Text, align:TableCellAligns.Center, value: rowData.code };
      else if (accessor === 'decimal')
        return { type: TableCellTypes.Number, align:TableCellAligns.Center, value: rowData.decimal, decimal: 0 };
      else if (accessor === 'symbol')
        return { type: TableCellTypes.Text, align:TableCellAligns.Center, value: rowData.symbol };
      else if (accessor === 'localSymbol')
        return { type: TableCellTypes.Text, align:TableCellAligns.Center, value: rowData.localSymbol };
      else if (accessor === 'inactive')
        return { type: TableCellTypes.Checkbox, value: rowData.inactive, onChangeFunc: (inactive: boolean) => cellValueChanged(rowIndex, accessor, inactive) };
      else
        return undefined;
    },
    isCellLock: (accessor: string, rowData: any): boolean => {
     if(!(listSec?.grantAdd || listSec?.grantEdit || listSec?.grantDel))
       return true
     else
       return false;
    },
    orderBy: [orderBy],
    onHeaderClick,
    useEditControls: (listSec?.grantAdd || listSec?.grantEdit || listSec?.grantDel),
    //useTableHelperText: (listSec?.grantAdd || listSec?.grantEdit || listSec?.grantDel),
  };
  
  useEffect(() => {
    if (isFilterObjectEmpty(search) && search.version === 1) reload(false);

    return () => {
      removeData();
    };
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  useEffect(() => {
    if (loading || (isFilterObjectEmpty(search) && search.version === 1)) {
      return;
    }
    fetchData(appContext.api, isFilterObjectEmpty(search));
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [search]
  );
  
  useEffect(() => {
    if (dataRef.current?.length > 0 && !loading) {
      oriData.current = _.cloneDeep(data);
      savedDataRef.current = _.cloneDeep(data);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [loading]
  );

  return (
    <div style={{ marginTop: '40px' }}>
      {/* <Portal node={document && document.getElementById('settings-placeholder')}>
        <h1>Currency Code</h1>
      </Portal> */}
      {/* <div className="reference-codes-title-row">

          <div style={{marginLeft: '10px', fontSize: '11px', fontWeight: 'bold'}}>
            Double Click Currency to Edit
          </div> 
          
        </div> */}

      <Portal node={document && document.getElementById('settings-command-placeholder')}>
        <div style={{display:'flex', width:'100px'}}>
          <div className="ifms-common-bar-element-center">
            <GreenButton size="regular" disabled={loading} onClick={save}><span style={{ textDecoration: 'underline' }}>S</span>ave</GreenButton>
          </div>
          <div style={{margin:'auto'}}></div>
          <div className="ifms-common-bar-element-center">
            <CloseButton onlyIcon name='settings-close' mode='light' onClick={refContext.cancel} />
          </div>
        </div>
      </Portal>

      <div style={{ display: 'flex', width: '432px' }}>
        <div style={{ marginLeft: 'auto' }}></div>
        <div style={{ position: 'relative', top: '-4px' }}>
          {/* <SecondaryButton name='codes-currency-add-button' size="regular" disabled={!canBeAdd} onClick={selectCurrencyForNew}><FontAwesomeIcon icon={faPlus} />&nbsp; New</SecondaryButton>&nbsp;&nbsp;
          <SecondaryButton name='codes-currency-edit-button' size="regular" disabled={!canBeEdit} onClick={selectCurrencyForEdit}><FontAwesomeIcon icon={faPencilAlt} />&nbsp; Edit</SecondaryButton>&nbsp;&nbsp;
          <SecondaryButton name='codes-currency-view-button' size="regular" disabled={!hasSelectedRow} onClick={selectCurrencyForView}><FontAwesomeIcon icon={faFileAlt} />&nbsp; View</SecondaryButton>&nbsp;&nbsp;
          <SecondaryButton name='codes-currency-delete-button' size="regular" disabled={!canBeDeleted} onClick={selectCurrencyForDelete}><FontAwesomeIcon icon={faTrashAlt} />&nbsp; Delete</SecondaryButton>&nbsp; */}

          <div style={{ display: 'none' }}>
            <FilterButton /> &nbsp;&nbsp;
          </div>
          {/* <BlackInverseButton data-nocellvalidate={true} name='codes-currency-refresh-button' size="large" disabled={loading} onClick={() => { reload(true); }} data-tooltip="Refresh" >
            <FontAwesomeIcon color='#47C83E' icon={faSync} />
          </BlackInverseButton> */}
          <RefreshIconButton2 name='codes-currency-refresh-button' onClick={() => { reload(true); }} disabled={loading} data-tooltip="Refresh"/>
        </div>
      </div>

      <div style={{ width: '432px' }}>
        {/* <SmartTable {...currencyTableOptions} /> */}
        {/* <IfmsModal isOpen={!!currency} title={currency && currency.id > 0 ? (currency.view ? 'Currency View' : 'Currency Edit') : 'Currency New'} onCancel={cancelOperation}>
          {!!currency &&
            <div>
              <div style={{ display: 'flex' }}>
                <div style={{ marginLeft: 'auto' }}></div>
                <div className="ifms-common-bar-element ifms-right-separator-light-gray">
                  {currency.view && listSec?.grantEdit &&
                    <PrimaryButton name='currency-detail-edit-button' size="regular" onClick={() => setCurrency({ view: false }, true)}><FontAwesomeIcon icon={faPencilAlt} />&nbsp;Edit</PrimaryButton>
                  }
                  {!currency.view &&
                    <GreenButton name='currency-detail-save-button' size="regular" onClick={save}>Save</GreenButton>
                  }
                  &nbsp;
                </div>&nbsp;&nbsp;
                <div className="ifms-common-bar-element">
                  <CloseButton name='currency-detail-close-button' onClick={cancelOperation} />
                </div>
              </div>
              <CurrencyDetail readonly={(currency.view)} currency={currency} onChange={setCurrency} />
              <div style={{ clear: 'both' }}></div>
            </div>
          }
        </IfmsModal> */}

        <EditableTable
          initializeFocusedCell={focusFirstCell}
          tableOptions={currencyTableOptions}
          deleteLine={deleteEntity}
          addLine={addLineItem}
          canDeleteRow={() => listSec?.grantDel ?? false}
        />
      </div>
    </div>
  );
}

export default CurrencyCodes;
